import { render, staticRenderFns } from "./infoBtn.vue?vue&type=template&id=3f094d66&scoped=true"
import script from "./infoBtn.vue?vue&type=script&lang=js"
export * from "./infoBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f094d66",
  null
  
)

export default component.exports